import { Hero } from "@/components/landing/Hero";
import { NetworkBento } from "@/components/landing/NetworkBento";
import { Marquee } from "@/components/Marquee";
import { Alliance } from "@/components/landing/Alliance";
import { Solutions } from "@/components/landing/Solutions";
import { Process, ClosingCTA } from "@/components/landing/Process";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Hero />
      <Marquee />
      <NetworkBento />
      <Alliance />
      <Solutions />
      <Process />
      <ClosingCTA />
    </main>
  );
}
